import { render, staticRenderFns } from "./addWalletOffers.vue?vue&type=template&id=64a0a10e&lang=true"
import script from "./addWalletOffers.vue?vue&type=script&lang=js"
export * from "./addWalletOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports